import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import CopyButton from '../../../commonUI/CopyButton';
import { flexCenter } from '../../../commonUI/cssClasses';
import useMeasureAcres from '../../../map/features/acreMeasure/hooks/useMeasureAcres';
import { roundFractional } from '../../../ranches/ranchUtils';
const fontSize = '0.8rem';

const CalculatedAcresDisplay: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { calculatedAcres } = useMeasureAcres(undefined, true);

  const roundedAcres = calculatedAcres
    ? roundFractional(calculatedAcres, 2)
    : null;

  return (
    <Box
      sx={{
        ...flexCenter,
        flexDirection: 'row',
        flexWrap: 'nowrap',
        bgcolor: theme.colors.darkTheme.grey.dark,
        p: '0.2rem',
        pl: '0.5rem',
        borderRadius: theme.borderRadius.primary,
      }}
    >
      <Typography variant='h6' sx={{ fontSize: fontSize }}>
        {t('Map Acres')}:
      </Typography>
      <Typography
        variant='h6'
        sx={{
          color: theme.colors.common.bloomfieldGreen,
          ml: 1,
          fontSize: fontSize,
        }}
      >
        {calculatedAcres ? roundedAcres : 'N/A'}
      </Typography>
      {roundedAcres && <CopyButton textToCopy={roundedAcres} />}
    </Box>
  );
};

export default CalculatedAcresDisplay;
